import { createStyles, makeStyles } from '@material-ui/core';

import { colorVariables } from '../../../../styles/colorVariables';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    noTransactions: {
      textAlign: 'center',
      fontSize: 14,
      marginTop: 24,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 12,
      },
    },
    tableHead: {
      backgroundColor: '#F5F7F9',
    },
    tableHeadCell: {
      '&.MuiTableCell-root': {
        fontWeight: 700,
        textAlign: 'center',
        padding: theme.spacing(1.5, 2),
        borderBottom: `1px solid ${theme.palette.divider}`,
        borderRight: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
        fontSize: 16,
        backgroundColor: '#F5F7F9',
        '&:last-child': { // Remove right border from last header cell
          borderRight: 0,
        },
        [theme.breakpoints.down(Sizes.mobile)]: {
          padding: theme.spacing(1.5, 1.5),
          fontSize: 12,
        },
      }
    },
  }),
);
